import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ADMIN } from '../../helpers/Constants';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from 'src/store/actions/authAction';

const AdminGuard = ({ children }) => {
  const { isAuthenticated, user } = useSelector(state => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    if (user) {
      axios.get(`/api/backoffice/user/${user?.id}`).then(res => {
        const { data } = res;
        if (
          user?.email !== data?.email ||
          user?.id !== data?.id ||
          user?.tipo !== data?.tipo
        ) {
          dispatch(logout());
        }
      });
    }

    // eslint-disable-next-line
  }, []);

  if (isAuthenticated) {
    if (user.tipo !== ADMIN) return <Redirect to="/" />;
  } else {
    return <Redirect to="/" />;
  }

  return <>{children}</>;
};

AdminGuard.propTypes = {
  children: PropTypes.node
};

export default AdminGuard;
